module.exports = __webpack_public_path__ + "img/flow_red.35ffbb84.svg";